<template>
  <!-- On mobile -->
  <div class="flex justify-center md:hidden">
    <RevLink
      class="body-1-link"
      :tracking="{
        zone: TRACKING_ZONES.POLICY_DETAILS,
        name: 'see-coverage-details',
      }"
      @click="openModal(MODAL_NAMES.COVERAGE_DETAILS_DRAWER)"
    >
      {{ i18n(translations.seeCoverageDetails) }}
    </RevLink>
  </div>

  <RevDialog
    :name="MODAL_NAMES.COVERAGE_DETAILS_DRAWER"
    :title="i18n(translations.coverageDetailsDrawerTitle)"
  >
    <template #body>
      <ul class="divide-static-default-low space-y-12 divide-y">
        <li v-for="benefit in benefits" :key="benefit">
          <div class="my-12 flex gap-8">
            <div class="min-w-[24px]">
              <IconCheckInCircleFilled class="text-static-success-hi" />
            </div>
            <div class="body-1">{{ benefit }}</div>
          </div>
        </li>
      </ul>
    </template>
  </RevDialog>

  <!-- On desktop -->
  <div class="hidden md:block">
    <RevDivider class="relative -inset-x-[32px] w-[calc(100%+64px)]" />
    <RevAccordionItem
      @click="
        track.trackClick({
          name: 'open-coverage-details-accordion',
          zone: TRACKING_ZONES.POLICY_DETAILS,
        })
      "
    >
      <template #title>
        <div class="body-1">{{ i18n(translations.seeCoverageDetails) }}</div>
      </template>
      <template #body>
        <ul class="divide-static-default-low space-y-12 divide-y">
          <li v-for="benefit in benefits" :key="benefit">
            <div class="my-12 flex gap-8">
              <div class="min-w-[24px]">
                <IconCheckInCircleFilled class="text-static-success-hi" />
              </div>
              <div class="body-1">{{ benefit }}</div>
            </div>
          </li>
        </ul>
      </template>
    </RevAccordionItem>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { useTracking } from '@backmarket/nuxt-module-tracking/useTracking'
import { RevAccordionItem } from '@ds/components/AccordionItem'
import { RevDialog } from '@ds/components/Dialog'
import { RevDivider } from '@ds/components/Divider'
import { RevLink } from '@ds/components/Link'
import { openModal } from '@ds/components/ModalBase'
import { IconCheckInCircleFilled } from '@ds/icons/IconCheckInCircleFilled'

import {
  MODAL_NAMES,
  TRACKING_ZONES,
} from '~/scopes/dashboard/services-hub/constant'

import translations from './CoverageDetails.translations'

const i18n = useI18n()
const track = useTracking()

defineProps<{
  benefits: string[]
}>()
</script>
